export default __webpack_public_path__ + "media/zurb/img/about/bryan/linkedin-icon-d48774c90480d8473d8b304fde46d9c1.svg";